import * as React from "react";
import {IMessageProps} from "./~types/MessageProps";
import { getDateTime } from "../../../../shared/helpers/date-helper/DateFormats";

import "./Message.css";

export default class Message extends React.Component<IMessageProps> {
    public render() {
        return (
            <div className={this.props.className + " message"} data-color-mode="light">
                <div className="message__content">
                    {this.props.children}
                    <div className="message__created-date">{getDateTime(this.props.createdDate)}</div>
                </div>
            </div>
        );
    }
}
